/* eslint-disable linebreak-style */
import {
  updateUser,
  updateAddress,
  createAddress
} from '../services/GraphQlClientService'
import {
  validateFirstOrLast,
  validateEmail,
  segmentEvent
} from '.'
import { formatGooglePlaceToAddress } from '.'
import { isValidPhoneNumber } from 'react-phone-number-input'
import { omit } from 'lodash'

export const validateAndUpdateUser = async (
  state,
  user,
  setUser,
  dispatch,
  closeModal,
  setWorking
) => {
  try {
    const errors = []

    if (!validateFirstOrLast(state.nameFirst)) {
      errors.push('nameFirstError')
    }

    if (!validateFirstOrLast(state.nameLast)) {
      errors.push('nameLastError')
    }

    if (!validateEmail(state.email)) {
      errors.push('emailError')
    }

    if (!isValidPhoneNumber(state.phone)) {
      errors.push('phoneError')
    }

    if (errors.length) {
      dispatch({ type: 'SET_ERRORS', fields: errors })
      setWorking(false)
      return
    }

    const updated = await updateUser({
      id: user.id,
      nameFirst: state.nameFirst,
      nameLast: state.nameLast,
      email: state.email,
      phone: state.phone,
      fullName: `${state.nameFirst} ${state.nameLast}`
    })

    setUser({
      ...user,
      nameFirst: updated.nameFirst,
      nameLast: updated.nameLast,
      email: updated.email,
      phone: updated.phone,
      fullName: updated.fullName
    })
    setWorking(false)
    closeModal()
  } catch (e) {
    console.error(e)
    dispatch({ type: 'SET_ERRORS', fields: ['saveError'] })
    setWorking(false)
  }
}

export const validateAndUpdatePassword = async (
  state,
  user,
  setUser,
  dispatch,
  closeModal,
  setWorking
) => {
  try {
    const { password, confirm } = state
    if (password !== confirm) {
      dispatch({
        type: 'SET_ERROR',
        message: 'Passwords do not match'
      })
      setWorking(false)
      return
    }
    if (password.length < 6) {
      dispatch({
        type: 'SET_ERROR',
        message: 'Password is not long enough (at least 6 characters)'
      })
      setWorking(false)
      return
    }

    const updated = await updateUser({ id: user.id, password })
    setWorking(false)
    dispatch({ type: 'SUCCESS' })
    setUser({ ...user, ...updated })
    setTimeout(closeModal, 2000)
  } catch (e) {
    console.error(e)
    dispatch({ type: 'SET_ERROR', message: 'Something went wrong, try again' })
    setWorking(false)
  }
}

export const validateAndUpdateAddress = async (
  { location, pets, notes, type, apartment },
  selectedAddress,
  user,
  setUser,
  closeModal,
  dispatch,
  updateAddressForApt,
  setWorking,
  markets
) => {
  try {

    let newAddress = {
      pets: pets || null,
      notes: notes || null,
      apartment: apartment || null,
      type
    }

    if (selectedAddress.newOrExisting === 'existing') {
      const formatted = location && formatGooglePlaceToAddress(location)

      if (!!location && !formatted) {
        setWorking(false)
        dispatch({ type: 'SET_ERRORS', fields: ['saveError'] })
        return
      }

      if (location) {
        newAddress = { ...newAddress, ...formatted }
      }

      const updated = await updateAddress(selectedAddress.id, newAddress)

      setWorking(false)

      if (updateAddressForApt) {
        updateAddressForApt({ address: omit({ ...selectedAddress, ...updated }, '__typename') })
      } else {
        setUser({
          ...user,
          addresses: user.addresses.map(a =>
            omit(a.id === updated.id ? updated : a, '__typename')
          )
        })

        let storage = JSON.parse(sessionStorage.getItem('book'))
        if (storage && !!updated.marketId) {
          const updatedSelectedAddress = storage?.address && storage?.address?.id === updated.id ? updated : storage?.address
          sessionStorage.setItem(
            'book',
            JSON.stringify({
              ...storage,
              addresses: [...storage.addresses.map(a => a.id === updated.id ? updated : a)],
              address: updatedSelectedAddress
            })
          )
        }
      }

      segmentEvent('web.modify.address', {
        newAddress: updated,
        path: window.document.location.pathname
      })
      closeModal()
    } else {
      const errors = []
      if (!location) { errors.push('locationError') }
      if (!type) { errors.push('typeError') }
      if (errors.length) {
        dispatch({ type: 'SET_ERRORS', fields: errors })
        setWorking(false)
        return
      }

      const formatted = formatGooglePlaceToAddress(location)

      if (!formatted) {
        setWorking(false)
        dispatch({ type: 'SET_ERRORS', fields: ['saveError'] })
        return
      }
      
      newAddress = {
        ...newAddress,
        ...formatted,
        userId: user.id
      }
      const _newAddress = await createAddress(newAddress)
      setUser({
        ...user,
        addresses: [_newAddress, ...user.addresses]
      })
      let storage = JSON.parse(sessionStorage.getItem('book'))
      if (storage && !!_newAddress.marketId) {
        const updatedAddressList = storage?.addresses?.length ? [_newAddress, ...storage.addresses] : [_newAddress]
        sessionStorage.setItem(
          'book',
          JSON.stringify({
            ...storage,
            address: { ..._newAddress },
            addresses: updatedAddressList,
            market: { ...markets.find(({ id }) => id === _newAddress.marketId) },
            allowAddressSelect: updatedAddressList.length
          })
        )
      }
      setWorking(false)
      closeModal()
    }
  } catch (e) {
    console.error(e)
    setWorking(false)
    dispatch({ type: 'SET_ERRORS', fields: ['saveError'] })
  }
}
